/**
 * ECharts theming derived from the active antd token so charts stay legible in
 * BOTH light and dark mode.
 *
 * ECharts' built-in axis / label / legend colors are a fixed dark gray (~#333)
 * that disappears on a dark canvas. These helpers supply token-driven colors
 * instead. Spread them into the relevant option node; when an axis also needs a
 * formatter, spread the helper first then override `axisLabel`:
 *
 *   xAxis: { type: 'category', data, ...themedCatAxis(token),
 *            axisLabel: { color: token.colorTextTertiary, formatter } }
 *
 * `token` is the object returned by antd's `theme.useToken()`.
 */

export function themedCatAxis(token: any) {
  return {
    axisLabel: { color: token.colorTextTertiary },
    axisLine: { lineStyle: { color: token.colorBorderSecondary } },
    axisTick: { lineStyle: { color: token.colorBorderSecondary } },
  };
}

export function themedValAxis(token: any) {
  return {
    axisLabel: { color: token.colorTextTertiary },
    splitLine: { lineStyle: { color: token.colorBorderSecondary, type: 'dashed' } },
  };
}

export const themedLegendText = (token: any) => ({ color: token.colorTextSecondary });

export const themedLabel = (token: any) => ({ color: token.colorTextSecondary });

/** Tooltip box styled to match the active theme (dark popovers in dark mode). */
export function themedTooltip(token: any) {
  return {
    backgroundColor: token.colorBgElevated,
    borderColor: token.colorBorderSecondary,
    textStyle: { color: token.colorText },
  };
}
